module.exports = __webpack_public_path__ + "img/horloge_cover.6d95dd31.jpg";